import styled, { css } from "styled-components";

const largeMenuItemStyles = css`
    height: 380px
`;

const getLargeMenuItem = props => {
    if(props.large) return largeMenuItemStyles
}

export const MenuItemContainer = styled.div`
    min-width: 30%;
    height: 320px;
    flex: 1 1 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid black;
    margin: 0 7.5px 15px;
    overflow: hidden;
    border-radius: 30px;

    &:hover {
        cursor: pointer;
    }

    &${getLargeMenuItem}
    
    &:first-child {
        margin-right: 7.5px;
    }
    
    &:last-child {
        margin-left: 7.5px;
    }
    
    @media screen and (max-width: 800px) {
        width: 50%;
    }
`;

export const MenuItemBackgroundImage = styled.div`
    width: 100%;
    height: 100%;
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    background-image: ${({ imageUrl }) => `url(${imageUrl})`};

    &:hover {
        transform: scale(1.1);
        transition: transform 6s cubic-bezier(0.25, 0.45, 0.45, 0.95);
    }
`;

export const MenuItemContentContainer = styled.div`
    height: 90px;
    padding: 0 25px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: 1px solid black;
    background-color:  white;
    opacity: 0.7;
    position: absolute;
`;

export const MenuItemContentTitle = styled.h1`
    font-weight: bold;
    margin-bottom: 6px;
    font-size: 22px;
    color: #4a4a4a; 

    &:hover {
        opacity: 0.9;

    }
`;

export const MenuItemContentSubtitle = styled.span`
    font-weight: lighter;
    font-size: 16px;

    &:hover {
        opacity: 0.9;

    }
`;